import { Component } from "react"
import dispatchEvent from "../../helpers/dispatch-event"
import { root } from "../../services/Globals"

const noop = () => {}

export default class PostScore extends Component {
  constructor(props) {
    super(props)
    this.initialState = {
      mode: `idle`,
      payload: undefined,
    }
    this.state = this.initialState
  }

  render = () => {
    const {
      state: { mode, payload },
      create,
    } = this

    return this.props.children({
      mode,
      payload,
      create,
    })
  }

  create = (data = {}) => {
    const {
      arrangementId,
      versionId,
      onSuccess = noop,
      onError = noop,
      onLoading = noop,
    } = this.props

    this.setState(
      previousState => ({
        ...previousState,
        mode: `loading`,
      }),
      onLoading
    )

    return root.wav
      .api({
        method: `post`,
        url: `/arrangements/${ arrangementId }/versions/${ versionId }/score`,
        data: { ...this.props.data, ...data },
      })
      .then(response => {
        onSuccess(response.data)
        dispatchEvent(`update:${ arrangementId }`)
        dispatchEvent(`update:${ versionId }`)
        dispatchEvent(`create:score`)
        return response
      })
      .catch(error => {
        this.setState(
          previousState => ({
            ...previousState,
            mode: `error`,
            payload: error,
          }),
          () => onError(error)
        )
      })
  }
}
